import { render, staticRenderFns } from "./Follower.vue?vue&type=template&id=0281cef9&scoped=true"
import script from "./Follower.vue?vue&type=script&lang=js"
export * from "./Follower.vue?vue&type=script&lang=js"
import style0 from "./Follower.vue?vue&type=style&index=0&id=0281cef9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281cef9",
  null
  
)

export default component.exports